import React from 'react';
import PropTypes from 'prop-types';

import {ReactComponent as ArrowUp} from "assets/img/arrow-up.svg";
import {ReactComponent as ArrowDown} from "assets/img/arrow-down.svg";
import {ReactComponent as ArrowDouble} from "assets/img/arrow-double.svg";
import {grey300} from "../../assets/jss/main";

ArrowButton.propTypes = {
    open: PropTypes.bool,
    onClick: PropTypes.func,
    doubleArrow: PropTypes.bool
};

function ArrowButton({ open = false, onClick = () => {}, doubleArrow = false, endAdornment = null, ...props}) {
    return (
        <div
            onClick={onClick}
            style={{
                padding: '8px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                borderRadius: '8px',
                cursor: 'pointer',
                ...open && {
                    backgroundColor: grey300
                }
            }}
        >
            {props.children}
            <div style={{
                display: 'flex',
                alignItems: 'center'
            }}>
                {open ? <ArrowUp /> : doubleArrow ?  <ArrowDouble /> : <ArrowDown />}
                {endAdornment}
            </div>

        </div>
    );
}

export default ArrowButton;
